import api from "@/components/customAxios/Axios";
import { useToast } from "@/components/toast";
import { useLoader } from "@/context/loaderContext";
import { useEffect, useState } from "react";
import {
	DropdownMenu,
	DropdownMenuContent,
	DropdownMenuItem,
	DropdownMenuLabel,
	DropdownMenuSeparator,
	DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
// import UserLogsModal from "./UserLogsModal";
import useRelativeTime from "@/hooks/useRelativeTime";
import { FiSearch } from "react-icons/fi";
import { Link } from "react-router-dom";
import Pagination from "../Pagination";
// import Pagination from "../Pagination";
type jobDetailListTypw = {
	assessments_sent: number;
	assessments_completed: number;
	total_cvs: number;
	jds_created: number;
	job_role: string;
	job_created_time: string;
	job_id: string;
	job_status: string;
	created_by_name: string
};

const UserLogs = () => {
	const { setLoading } = useLoader();
	const toast = useToast();
	const [userLogs, setUserLogs] = useState<Array<jobDetailListTypw>>([]);

	const [selectedStatus, setSelectedStatus] = useState("");

	const statusOptions = ["Active", "Closed", "On Hold", "Filled"];

	const handleSelect = (status: string) => {
		setSelectedStatus(status === "Clear" ? "" : status);
	};

	const [nameQuery, setNameQuery] = useState("");
	const [totalItems, setTotalItems] = useState(0);
	const [sortParam, setSortParam] = useState("-created_at");
	// const [sortOrder, setSortOrder] = useState("");
	const [currentPage, setCurrentPage] = useState(1);
	const [totalPages, setTotalPages] = useState(0);
	// const [itemsPerPage, setItemsPerPage] = useState(10);
	const handlePageClick = (page: number) => {
		setCurrentPage(page);
	};

	const getUserLogs = async () => {
		setLoading(true);
		const user_id = localStorage.getItem("user");
		try {
			const response = await api.get(`/job_details_list?user_id=${user_id}`, {
				params: {
					page: currentPage,
					search_value: nameQuery,
					per_page: 10,
					sort_by: sortParam,
					filter_value: selectedStatus,
				},
			});

			// const res = await api.get(`/dashboard/admin/users`, {
			// 	params: {
			// 		page: currentPage,
			// 		search: nameQuery,
			// 		per_page: itemsPerPage,
			// 		sort: sortParam,
			// 		order: sortOrder,
			// 	},
			// });
			if (response.status === 200) {
				setUserLogs(response.data.data);
				setTotalItems(response.data.total);
				setTotalPages(response.data.pages);
			}
		} catch (err: any) {
			setLoading(false);
			toast.error({
				type: "background",
				duration: 5000,
				status: "error",
				title: "Error Fetching Job Logs",
				description: err.response?.data?.error || err.response?.data?.message || "Failed to fetch Job logs. Please try again.",
				open: true,
			});
		} finally {
			setLoading(false);
		}
	};
	// const toggleParams = (field: string) => {
	// 	setSortParam(field);
	// 	setSortOrder((prev) => (prev === "asc" ? "desc" : "asc"));
	// };

	useEffect(() => {
		// Set a timeout for the search
		const handler = setTimeout(() => {
			getUserLogs();
		}, 2000);

		// Cleanup the timeout if searchQuery changes before 2 seconds
		return () => clearTimeout(handler);
	}, [nameQuery]);
	useEffect(() => {
		getUserLogs();
	}, [currentPage, sortParam, selectedStatus]);

	return (
		<div className=" mt-3 bg-white rounded-lg p-3  ">
			{/* User Logs Heading */}

			<h1 className="text-xl font-semibold  w-full md:w-auto   font-heading mb-3">
				Jobs
			</h1>

			<div className="flex justify-between gap-x-1 items-center mb-4 font-body bg-[#F9F9FA] p-1.5 rounded-xl">
				<div className="flex gap-x-3 items-center w-full md:w-auto">
					<div className="ml-2 relative group">
						<Link to="/add-job" className="shadow-md">
							<svg
								width="18"
								height="18"
								viewBox="0 0 18 18"
								fill="none"
								xmlns="http://www.w3.org/2000/svg"
							>
								<path
									d="M1 9H17"
									stroke="black"
									strokeWidth="1.5"
									strokeLinecap="round"
								/>
								<path
									d="M9 17L9 1"
									stroke="black"
									strokeWidth="1.5"
									strokeLinecap="round"
								/>
							</svg>
						</Link>
						<p className="absolute  w-[100px] text-center  ml-2 px-2 py-1 text-sm bg-black text-white rounded -z-10 group-hover:z-50 transition duration-300 ease-in-out">
							Create a Job
						</p>
					</div>
					<div className="relative group ml-2">
						<DropdownMenu>
							<DropdownMenuTrigger asChild>
								<button className="relative flex items-center gap-2 p-2  rounded hover:bg-gray-100 transition">
									{/* Hamburger Icon */}
									<svg
										width="21"
										height="12"
										viewBox="0 0 21 12"
										fill="none"
										xmlns="http://www.w3.org/2000/svg"
									>
										<path
											d="M1 1H20"
											stroke="black"
											strokeWidth="1.5"
											strokeLinecap="round"
										/>
										<path
											d="M5 6H16"
											stroke="black"
											strokeWidth="1.5"
											strokeLinecap="round"
										/>
										<path
											d="M9 11H12"
											stroke="black"
											strokeWidth="1.5"
											strokeLinecap="round"
										/>
									</svg>

									{/* Badge */}
									{selectedStatus && (
										<span className="absolute top-0 right-0 -mt-1 -mr-1 bg-red-500 text-white text-xs font-bold rounded-full w-4 h-4 flex items-center justify-center">
											!
										</span>
									)}
								</button>
							</DropdownMenuTrigger>

							<DropdownMenuContent className="w-56 p-3">
								<DropdownMenuLabel>Status</DropdownMenuLabel>
								<DropdownMenuSeparator />
								{statusOptions.map((status) => (
									<DropdownMenuItem
										key={status}
										onClick={() => handleSelect(status)}
										className={`${selectedStatus === status
											? "bg-gray-100 font-semibold"
											: ""
											} cursor-pointer`}
									>
										{status}
									</DropdownMenuItem>
								))}
								<DropdownMenuSeparator />
								<DropdownMenuItem
									className="cursor-pointer font-bold"
									onClick={() => handleSelect("Clear")}
								>
									Clear
								</DropdownMenuItem>
							</DropdownMenuContent>
						</DropdownMenu>
						<p className="absolute  w-[60px] text-center  ml-2 px-2 py-1 text-sm bg-black text-white rounded -z-10 group-hover:z-50 transition duration-300 ease-in-out">
							Filter
						</p>
					</div>
					<div
						className="ml-2 relative group"
						onClick={() =>
							setSortParam((prev) =>
								prev === "-created_at" ? "created_at" : "-created_at"
							)
						}
					>
						<svg
							width="18"
							height="16"
							viewBox="0 0 18 16"
							fill="none"
							xmlns="http://www.w3.org/2000/svg"
						>
							<path
								d="M14.3536 0.646447C14.1583 0.451184 13.8417 0.451184 13.6464 0.646447L10.4645 3.82843C10.2692 4.02369 10.2692 4.34027 10.4645 4.53553C10.6597 4.7308 10.9763 4.7308 11.1716 4.53553L14 1.70711L16.8284 4.53553C17.0237 4.7308 17.3403 4.7308 17.5355 4.53553C17.7308 4.34027 17.7308 4.02369 17.5355 3.82843L14.3536 0.646447ZM13.5 1L13.5 15H14.5L14.5 1H13.5Z"
								fill="black"
							/>
							<path
								d="M3.64645 15.3536C3.84171 15.5488 4.15829 15.5488 4.35355 15.3536L7.53553 12.1716C7.7308 11.9763 7.7308 11.6597 7.53553 11.4645C7.34027 11.2692 7.02369 11.2692 6.82843 11.4645L4 14.2929L1.17157 11.4645C0.976311 11.2692 0.659728 11.2692 0.464466 11.4645C0.269204 11.6597 0.269204 11.9763 0.464466 12.1716L3.64645 15.3536ZM4.5 15L4.5 1H3.5L3.5 15H4.5Z"
								fill="black"
							/>
						</svg>

						<p className="absolute  w-[50px] text-center  ml-2 px-2 py-1 text-sm bg-black text-white rounded -z-10 group-hover:z-50 transition duration-300 ease-in-out">
							Sort
						</p>
					</div>
				</div>

				<div className="flex gap-x-1 items-center w-full md:w-auto">
					<div className="relative  ">
						<span className="absolute inset-y-0 left-2 flex items-center text-gray-500">
							<FiSearch size={"18"} />
						</span>
						<input
							type="text"
							value={nameQuery}
							onChange={(e) => setNameQuery(e.target.value)}
							placeholder="Search here..."
							className="w-full p-1.5 pl-8 border  border-gray-300 rounded-lg f"
						/>
					</div>
				</div>
			</div>
			<div className="max-h-[930px] min-h-[930px] overflow-y-auto divide-y	">
				{userLogs.length > 0 ? (
					<>
						{" "}
						{userLogs.map((user) => (
							<div className="p-4 " key={user.job_id}>
								{/* Top Section */}
								<div className="flex justify-between">
									<div>
										<Link
											to={`/respective-dashboard/${user.job_id}`}
											className="text-lg font-semibold hover:underline text-[#438437] cursor-pointer"
										>
											{user.job_role}
										</Link>
										<div className="flex items-center gap-2 mt-1">
											<span className="text-sm text-gray-500">Created By:-</span>
											<span className="text-sm font-medium text-gray-700">{user.created_by_name}</span>
										</div>
										{/* <div className="text-gray-500 text-sm mt-1">
											Engineering • Remote
										</div> */}
									</div>
									<span
										className={`text-center p-2.5 h-10 px-3  rounded-3xl text-sm  ${user.job_status === "Active"
											? "bg-[#BDE4C3] text-[#438437]"
											: user.job_status === "Closed"
												? "bg-[#F7C5C5] text-[#CA4F4F]"
												: user.job_status === "On Hold" ? "bg-[#ffc55218] text-[#FFC452]" : "bg-blue-100 text-blue-500"
											}`}
									>
										{user.job_status}
									</span>
								</div>

								{/* Middle Section */}
								<div className="flex justify-between items-center mt-4">
									<div className="text-sm text-gray-700">
										Candidates: {user.total_cvs}
									</div>
									<div className="text-gray-500 text-sm">
										{useRelativeTime(user.job_created_time) === "Invalid date"
											? user.job_created_time
											: useRelativeTime(user.job_created_time)}{" "}
									</div>
								</div>

								{/* Bottom Section */}
								{/* <div className="mt-4">
									<div className="flex justify-between items-center mb-1">
										<div className="text-sm text-gray-700">Conversion Rate</div>
										<div className="text-gray-500 text-sm">30%</div>
									</div>
									<div className="w-full bg-gray-200 h-1.5 rounded-full">
										<div
											className="bg-black h-1.5 rounded-full"
											style={{ width: "30%" }}
										/>
									</div>
								</div> */}
							</div>
						))}
					</>
				) : (
					<div className="flex justify-center items-center">
						<div className=" text-3xl text-gray-500">No Job Found</div>
					</div>
				)}
			</div>
			{/* user log table */}
			{/* {

			<div className=" overflow-x-auto mt-3">
				<div className=" overflow-y-auto p-2">
					<table className="w-full min-w-[800px] text-sm ">
						<thead className="bg-white p-2 font-subheading sticky top-0 text-gray-500">
							<tr>
								<th className="p-3 text-left min-w-[180px]">Role</th>

								<th className="p-3 text-left min-w-[120px] max-w-[120px]">
									Total CV's{" "}
									<button
										className="text-blue-500 ml-1"
										// onClick={() => toggleParams("cv")}
									>
										<TiArrowUnsorted />
									</button>
								</th>
								<th className="p-3 text-left min-w-[110px] max-w-[130px]">
									Assessments Sent
									<button
										className="text-blue-500 ml-2"
										// onClick={() => toggleParams("assessment_sent")}
									>
										<TiArrowUnsorted />
									</button>
								</th>
								<th className="p-3 text-left min-w-[140px] max-w-[155px]">
									Assessments Completed{" "}
									<button
										className="text-blue-500 ml-2"
										// onClick={() => toggleParams("assessment_completed")}
									>
										<TiArrowUnsorted />
									</button>
								</th>
								<th className="p-3 text-left min-w-[120px] max-w-[125px]">
									Job Creation Time{" "}
									<button
										className="text-blue-500 ml-2 mt-1"
										// onClick={() => toggleParams("login_time")}
									>
										<TiArrowUnsorted />
									</button>
								</th>
							</tr>
						</thead>
						{userLogs.length > 0 ? (
							<>
								<tbody className="font-body">
									{userLogs.map((user) => (
										<tr
											key={user.job_id}
											className="border-b border-gray-300 hover:bg-slate-100"
										>
											{/* User Column */}
			{/* <td className="p-3 font-medium text-[#438437]">
												{user.job_role} */}
			{/* <UserLogsModal
													userName={user.user_name}
													userEmail={user.user_email}
												></UserLogsModal> */}
			{/* </td> */}
			{/* Other Columns */}
			{/* <td className="p-3 text-gray-700">{user.jds_created}</td> */}
			{/* <td className="p-3 text-gray-700">{user.total_cvs}</td> */}
			{/* <td className="p-3 text-gray-700">
												{user.assessments_sent}
											</td>
											<td className="p-3 text-gray-700">
												{user.assessments_completed}
											</td>
											<td className="p-3 text-gray-700">
												{useRelativeTime(user.job_created_time) ===
												"Invalid date"
													? user.job_created_time
													: useRelativeTime(user.job_created_time)}
											</td>
										</tr>
									))}
								</tbody> */}

			{/* <tfoot className="sticky bottom-0 bg-gray-100  font-subheading ">
									
								</tfoot> */}
			{/* </> */}
			{/* ) : ( */}
			{/* <tbody>
								<tr>
									<td
										colSpan={6}
										className="p-3 text-center font-semibold text-2xl text-gray-500"
									>
										No Data Found
									</td>
								</tr>
							</tbody>
						)}
					</table>
				</div>
			</div> } */}
			{userLogs.length > 0 && <Pagination
				dataLength={userLogs.length}
				currentPage={currentPage}
				handlePageClick={handlePageClick}
				totalItems={totalItems}
				totalPages={totalPages}
			/>}
		</div>
	);
};

export default UserLogs;
